(function ($, duo, undefined) {

  "use strict";

  /**
   * @class Header
   */
  class Header {

    /**
     * Creates an instance of Header
     * @param {string} headerSelector css selector for the Header element
     */
    constructor({ headerSelector = '.site-header' } = {}) {
      this.headerSelector = headerSelector;
      this.element = $(headerSelector);
      this.scrollPosition = 0;

      // setup:
      this.setup();
    }

    /**
     * Setup the Header
     */
    setup() {
      const self = this;

      // make "top actions" block visible:
      const $topActionsBlock = $(document).find('.site-header__top-actions-block');
      if ($topActionsBlock.length > 0) {
        $topActionsBlock.addClass('js-visible');
      }

      // user variables
      const user_link = '.block-user-link-block .user-link';
      const user_name = '.block-user-link-block .user-name';

      // cart variables
      const cart_menu = '.block-custom-cart-block';

      // language select variables
      const language = '.language-wrapper';
      const language_button = '.js-language-button';
      const language_content_wrapper = '.js-language-contentwrapper';

      $('.menu-item.menu-item--expanded a').on('focus', function (e) {
        const $parentItem = $(this).parents('.menu-item.menu-item--expanded');
        if ($parentItem.length > 0) {
          if (!$parentItem.hasClass('focus')) {
            $parentItem.addClass('focus');
          }
        }
      });
      $('.menu-item.menu-item--expanded a').on('blur', function (e) {
        const $parentItem = $(this).parents('.menu-item.menu-item--expanded');
        if ($parentItem.length > 0) {
          if ($parentItem.hasClass('focus')) {
            $parentItem.removeClass('focus');
          }
        }
      });

      // header - user event
      $(document).on('click', user_name, function (e) {
        e.preventDefault();
        $(user_link).toggleClass('is-active');
        hideLanguage(language_button, language_content_wrapper, language);
      });

      let $cartItemsBlock = $('.cart-block--contents__items');

      // header - check cart height (for transparent gradient)
      let cart_height = $('.cart-block--contents__inner').height() - 106; // 106 is the height from the cart title and the buttons
      let cart_content_height = $cartItemsBlock.find('.cart-block .views-element-container').height();
      if (cart_height < cart_content_height) {
        $cartItemsBlock.addClass('is-overflow'); // When there is an overflow add this class
      }

      // header - language select
      new duo.LanguageSelect({
        listSelector: '.language-switcher-language-url > ul'
      });

      // header - close pop-out when there is a click outside of the pop-out
      $(document).on('click touchstart', function (e) {
        var target = $(e.target);
        if (target.hasClass('user-name') || target.hasClass('user-menu') || target.hasClass('cart-block--summary__count') ||
          target.hasClass('js-language-button') || target.parents('.js-language-contentwrapper').length ||
          target.parents('.cart--cart-block').length ||
          target.parents('.cart-block--contents').length || target.attr('href')) {
          // --> do nothing
        } else {
          hideUserPopout(user_link);
          hideLanguage(language_button, language_content_wrapper, language);
        }
      });

      // header - responsive menu
      const responsive_menu_link = '.site-header__menu-toggle';

      $(document).on('click', responsive_menu_link, function (e) {
        if ($('html').hasClass('menu_is_active')) {
          $('html').removeClass('menu_is_active');
          $(window).scrollTop(self.scrollPosition);
          $('.page-wrapper').css('top', '');
        } else {
          self.scrollPosition = $(window).scrollTop();
          $('html').addClass('menu_is_active');
          $('.page-wrapper').css('top', '-' + self.scrollPosition + 'px');
        }
      });
      // -> close menu with escape:
      $(document).on('keydown.header', function (event) {
        if (event.keyCode === 27) {
          if ($('html').hasClass('menu_is_active')) {
            $('html').removeClass('menu_is_active');
            $('.page-wrapper').css('top', '');
            $(window).scrollTop(self.scrollPosition);
          }
          if ($('html').hasClass('search_is_active')) {
            $('html').removeClass('search_is_active');
            $('.page-wrapper').css('top', '');
            $(window).scrollTop(self.scrollPosition);
          }
        }
      });

      // header - responsive search
      const responsive_search_link = '.site-header__search-toggle';

      $(document).on('click', responsive_search_link, function (e) {
        if ($('html').hasClass('search_is_active')) {
          $('html').removeClass('search_is_active');
          $(window).scrollTop(self.scrollPosition);
          $('.page-wrapper').css('top', '');
        } else {
          self.scrollPosition = $(window).scrollTop();
          $('html').addClass('search_is_active');
          $('.page-wrapper').css('top', '-' + self.scrollPosition + 'px');
          $('.block-hairco-search .form-item input').focus();
        }
      });

      // header - responsive close
      const responsive_close_link = '.site-header__close-toggle, .overlay';

      $(document).on('click', responsive_close_link, function (e) {
        $('html').removeClass('menu_is_active');
        $('html').removeClass('search_is_active');
        $(window).scrollTop(self.scrollPosition);
        $('.page-wrapper').css('top', '');
      });

      const menuMediaQuery = window.matchMedia('(max-width: 82.25em)');
      if (menuMediaQuery.addEventListener) {
        menuMediaQuery.addEventListener('change', function () {
          if ($('html').hasClass('menu_is_active')) {
            $('html').removeClass('menu_is_active');
            $('.page-wrapper').css('top', '');
          }
          if ($('html').hasClass('search_is_active')) {
            $('html').removeClass('search_is_active');
            $('.page-wrapper').css('top', '');
          }
        });
      }

      // header - responsive reposition navigation
      const main_nav = $('.site-header__main-navigation');
      const region_header = $('.region-header');
      const site_header = $('.site-header__main-content');

      const cart = $('.region-header .block-custom-cart-block');
      const logo = $('.site-header__logo-zone');
      const user = $('.region-header .block-user-link-block');

      let mediaQuery = window.getComputedStyle(document.querySelector('html'), ':before').getPropertyValue('content').replace(/["']/g, "");

      if (mediaQuery === 'menu') {
        region_header.prepend(main_nav);
        cart.insertAfter(logo);
      }

      // on window resize:
      $(window).resize(function () {

        let mediaQuery = window.getComputedStyle(document.querySelector('html'), ':before').getPropertyValue('content').replace(/["']/g, "");

        if (mediaQuery === 'menu') {
          region_header.prepend(main_nav);
          cart.insertAfter(logo);
        } else {
          site_header.append(main_nav);
          cart.insertAfter(user);
        }

      });

      function hideLanguage(language_button, language_content_wrapper, language) {

        // --> hide language pop-out
        $(language_button).attr('aria-expanded', 'false');
        $(language_content_wrapper).attr('aria-hidden', 'true');
        $(language).removeClass('is-open');
      }

      function hideUserPopout(user_link) {
        // --> hide user pop-out
        $(user_link).removeClass('is-active');
      }
    }
  }

  duo.Header = Header;

})(jQuery, window.duo = window.duo || {});
